import { Link, useLoaderData, useNavigate, useParams } from "react-router-dom";
import { HeaderLink, PageHeaderLink } from "./helpers/elements";
import React, { useState } from "react";
import useFetch from "./helpers/useFetch";
import { truncate_letters } from "./helpers/utils";
import { useDeviceWidth } from "./useDeviceWidth";
import { NavBar } from "./Base";
import { FormFields } from "./CreateForm";
import axios from "axios";


function DeleteApp() {
    // const { appId } = useParams();
    const { app } = useLoaderData();
    const appData = app?.data;
    const navigate = useNavigate();
    // const [appData] = useFetch(`${process.env.REACT_APP_BASE_URL}/app/${id}/`);
    const { windowWidth, screenWidth, deviceWidthEnum } = useDeviceWidth();
    const [appName, setAppName] = useState("");
    const [deleteAppResponseData, setDeleteAppResponseData] = useState({});
    const [isSubmit, setIsSubmit] = useState(false)

    const showLoadingState = (e) => {
        setIsSubmit(true);
    };

    const handleAppDelete = (event) => {
        const deleteAppFormData = new FormData();
        const deleteAppURL = `${process.env.REACT_APP_BASE_URL}/app/${appData?.id}/`;
        // const deleteAppURL = "https://blessedmayowa.pythonanywhere.com/deleteApp/";
        const headers = {
            'Accept': '*/*',
            // 'Origin': '*',
        };
        const fetchInit = {
            method: 'DELETE',
            headers: headers,
            mode: 'cors',
            // body: deleteAppFormData,
            data: deleteAppFormData,
            cache: 'default',
        };
        event.preventDefault();

        // fetch(deleteAppURL, fetchInit)
        axios(deleteAppURL, fetchInit)
            .then(response => {
                if (response.status !== 200) {
                    throw response;
                }
                let error_message;
                if (response.status === 401) {
                    error_message = "Kindly login to proceed"
                } else if (response.status === 400) {
                    error_message = "Unable to delete this App. Kindly fix any errors and re-submit"
                } else if (response.status === 500) {
                    error_message = "Check your internet connection"
                } else {
                    // There is no network connection or the Server is not up.
                    error_message = "Oops. Network Error"
                }
                setDeleteAppResponseData({
                    message: error_message,
                    successful: false,
                    error: true
                });
                // return response.json();
                return response.data;
            })
            .then((data) => {
                // reset the delete form
                event.target.reset();
                // reset the isSubmit loader
                setIsSubmit(false);
                setDeleteAppResponseData({
                    message: "App Deleted successfully",
                    successful: true,
                    error: false
                });
                setTimeout(() => {
                    navigate('/');
                }, 800);
            })
            .catch((error) => {

                // reset the isSubmit loader
                setIsSubmit(false);
            });
    }

    return (
        <form
            method={"DELETE"}
            action={""}
            className="delete-app-form-container flex flex-column justify-start align-items-start pct:w-100 pct:h-100 overflow-x-hidden dark:bg-111314|color-whitesmoke"
            onSubmit={handleAppDelete}
        >
            {
                windowWidth < deviceWidthEnum.laptop
                    ? <PageHeaderLink headerTitle={`Delete ${appData?.name}`} fixTop={false} />
                    : <NavBar showSearch={false} />
            }

            {/*<AppBoxes {...appData} hideUser={true}/>*/}
            <section className={"pct:w-96 mg-x-auto mg-y2 pad-4 lh-4 bg-red-inverse radius lg:pct:w-56"}>
                <div>
                    <span className={"fa fa-warning font-16 color-red square-4 text-center"}></span>
                    <span className={"font-18"}>Warning</span>
                </div>
                This app will no longer be available on Nine once you click the delete button below.
                <div><b>This action cannot be undone.</b></div>
                {/*Are you sure you want to delete {appData?.name}?*/}
                <br />
                <div>
                    If you choose to proceed, type <b>{appData?.name}</b> in the text field below to delete this app.
                </div>
            </section>
            <section className={"d-block pct:w-100 z-1 lg:px:top-0|pct:w-56|mg-x-auto"}>
                <FormFields
                    useDefaultInput={true}
                    type={"text"}
                    name={"name"}
                    label_value={"Enter app name"}
                    required={true}
                    placeholder={`Type ${appData?.name} here`}
                    onChange={(event) => setAppName(event.target.value)}
                />
            </section>

            <section className={"d-block abs bottom-0 pct:w-100 h-80 lh-2 mg-x-auto pad-x2"}>
                <button
                    className={"d-block pct:w-100 h-6 lh-6 font-semibold border-0 outline-red outline-offset-2 bg-red color-white cursor-pointer radius disabled:bg-red-inverse|cursor-not-allowed lg:pct:w-40|mg-x-auto"}
                    disabled={appName !== appData?.name}
                    onClick={showLoadingState}
                    type={"submit"}
                >
                    {isSubmit ? <span className='fa fa-spinner fa-spin'></span> : "Delete"}
                </button>
            </section>
        </form>
    )
}

export default DeleteApp